import React from 'react';
import type ProjectSettingsServiceDeskAutomationEditRuleType from '@atlassian/jira-spa-apps-project-settings-service-desk-automation-edit-rule/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskAutomationEditRule = lazyForPaint<
	typeof ProjectSettingsServiceDeskAutomationEditRuleType
>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-automation-edit-rule", jiraSpaEntry: "async-project-settings-service-desk-automation-edit-rule" */ '@atlassian/jira-spa-apps-project-settings-service-desk-automation-edit-rule'
		),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskAutomationEditRule}
		pageId="project-settings-automation-edit-rule"
		shouldShowSpinner
	/>
);
